import type { RenderComponentProps } from "../../../shared/types";

import * as React from "react";

import { useProductFromProps } from "../../hooks/useProductFromProps";
import { wrapProductAssignmentToLiquidSource } from "../../utils/reviews";
import { SharedShopifyLiquid } from "../SharedShopifyLiquid";

const RebuyWidget: React.FC<RenderComponentProps> = ({
  componentAttributes: attributes,
  component,
  context,
}) => {
  const rebuyWidgetEmbed = component.props._rebuyWidgetEmbed;
  const product = useProductFromProps(component.props, context);

  const rebuyEmbedIncludesProductId = rebuyWidgetEmbed?.includes(
    "data-rebuy-shopify-product-ids",
  );

  const rebuyWidgetIdRegex = rebuyWidgetEmbed?.match(
    /data-rebuy-id="(\d+)"/,
  )?.[1];

  let liquidSource = `<div data-rebuy-id="${rebuyWidgetIdRegex}"${
    rebuyEmbedIncludesProductId
      ? ' data-rebuy-shopify-product-ids="{{ product.id }}"'
      : ""
  }></div>`;

  if (rebuyEmbedIncludesProductId) {
    liquidSource = wrapProductAssignmentToLiquidSource({
      product,
      liquidSource,
      context: context,
    });
  }

  return (
    <SharedShopifyLiquid
      liquidSource={liquidSource}
      componentId={component.id}
      componentAttributes={attributes}
      title="Rebuy Widget"
      placeholderType="productOptions"
      isLiquidSupported
    />
  );
};

export default RebuyWidget;
